import { GridColDef, GridColumnVisibilityModel } from '@mui/x-data-grid-pro'
import {
  selectImportColumnOrder,
  useLoadListViewPreferencesOnce,
} from '@user/store/userPreferences'
import { useSelector } from 'react-redux'
import { importColumnDefinitions } from './importColumnDefinitions'
import { useMemo } from 'react'

export function useImportColumnsSettings() {
  const userPrefsLoading = useLoadListViewPreferencesOnce()
  const savedImportColumnPreferences = useSelector(selectImportColumnOrder)
  const actionField = 'actions'

  const columnsToEdit = useMemo(
    (): GridColDef[] =>
      importColumnDefinitions.filter((column) => column.field !== actionField),
    [],
  )

  const actionColumn = useMemo(
    (): GridColDef | undefined =>
      importColumnDefinitions.find((column) => column.field === actionField),
    [],
  )

  const lockedImportColumns = [actionField, 'name']

  const [orderedColumns, columnVisibility] = useMemo(() => {
    let orderedColumns: GridColDef[] = []
    const columnVisibility: GridColumnVisibilityModel = {}

    if (
      savedImportColumnPreferences.length === 0 ||
      savedImportColumnPreferences.length !== importColumnDefinitions.length
    ) {
      importColumnDefinitions.map((column) => {
        columnVisibility[column.field] = true
        orderedColumns.push(column)
      })
    } else {
      orderedColumns = savedImportColumnPreferences.reduce<GridColDef[]>(
        (prev, { field, hide, width }) => {
          const index = [...importColumnDefinitions].findIndex(
            (c) => c.field === field,
          )
          if (index !== -1) {
            const column = [...importColumnDefinitions].splice(index, 1).pop()!
            columnVisibility[field] = !hide

            if (width) {
              column.width = parseInt(width)
            }
            return [...prev, column]
          }
          return prev
        },
        [],
      )

      if (actionColumn && !orderedColumns.includes(actionColumn)) {
        orderedColumns.unshift(actionColumn)
      }
    }
    return [orderedColumns, columnVisibility]
  }, [savedImportColumnPreferences, actionColumn])

  const defaultImportsColumnsVisibility = [
    ...importColumnDefinitions,
  ].reduce<GridColumnVisibilityModel>(
    (acc, { field }) => {
      if (acc[field] === undefined) {
        return { ...acc, [field]: true }
      } else return acc
    },
    {
      // columns hidden by default
      status: false,
      totalRecords: false,
    },
  )

  const defaultImportColumns = [...importColumnDefinitions].map((c) => c.field)

  return {
    lockedImportColumns,
    columnsToEdit,
    orderedColumns,
    columnVisibility,
    userPrefsLoading,
    defaultImportsColumnsVisibility,
    defaultImportColumns,
  }
}
